import { useEffect } from "react";
import gsap from "gsap";
import { getCaps } from "@/studio/lib/perf";

/**
 * Adds a subtle gravity ripple to clicks — desktop / high-tier only.
 * Disabled on touch, low-power and reduced-motion devices.
 */
export default function GravityRipple() {
  useEffect(() => {
    const caps = getCaps();
    if (!caps.ripple) return undefined;

    const isGravity = () =>
      document.querySelector(".studio-root")?.dataset.gravityMode === "true";

    const make = (x, y, delay = 0) => {
      const ring = document.createElement("div");
      ring.className = "studio-ripple";
      const start = 6;
      ring.style.cssText = `
        left:${x - start / 2}px;top:${y - start / 2}px;
        width:${start}px;height:${start}px;opacity:1;
      `;
      document.body.appendChild(ring);
      gsap.to(ring, {
        width: 320,
        height: 320,
        left: x - 160,
        top: y - 160,
        opacity: 0,
        duration: 1.05,
        delay,
        ease: "expo.out",
        onComplete: () => ring.remove(),
      });
    };

    const onClick = (e) => {
      // ignore non-primary mouse buttons and synthetic events on hidden els
      if (e.button !== undefined && e.button !== 0) return;
      make(e.clientX, e.clientY);
      if (isGravity()) make(e.clientX, e.clientY, 0.12);
    };

    window.addEventListener("pointerdown", onClick, { passive: true });
    return () => window.removeEventListener("pointerdown", onClick);
  }, []);

  return null;
}
